/**
 * Copyright (C) SiteVision AB 2002-2026, all rights reserved
 */
import '../shared/svAutoComplete/jquery.svAutoComplete';

import { initSearchForm } from './searchForm';

document.querySelectorAll('.sv-searchform-portlet').forEach(initSearchForm);
